define('TescoMobile_Checkout/js/stay-in-checkout',['uiComponent', 'jquery', 'Magento_Ui/js/modal/confirm', 'mage/translate'], function (Component, $, confirmModal, $t) {
  'use strict';

  return Component.extend({
    initialize: function () {
      var _self = this;
      this._super();
      var backTitle, backButton;
      $('.stay-on-checkout-trigger').on('click', function (e) {
        if ($(e.target).parents('.logo').length) {
          backTitle = $t('Are you sure you want to return to the homepage?'), backButton = $t('Back to homepage');
        } else {
          backTitle = $t('Are you sure you want to return to your basket?');
          backButton = $t('Back to basket');
        }
        _self.modalInit(this.href, backTitle, backButton);
        e.preventDefault();
      });
    },
    modalInit: function (logoHref, backTitle, backButton) {
      confirmModal({
        title: backTitle,
        type: 'popup',
        modalClass: 'stay-in-checkout',
        clickableOverlay: false,
        buttons: [{
          text: $t('Stay in checkout'),
          class: 'action-primary action-dismiss',
          click: function (event) {
            this.closeModal(event);
          }
        }, {
          text: backButton,
          class: 'action-primary action-accept',
          click: function (event) {
            window.location.href = logoHref;
            this.closeModal(event, true);
          }
        }]
      });
    }
  });
});

